import {
  compose,
  css,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  variant,
} from '@wrisk/styled-system'
import { isNil } from 'lodash-es'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { TransitionProps } from '../../transition'
import { mdBumps } from '../layout'

type DragBoxProperty = 'default' | 'active'

export interface DragBoxProps extends TransitionProps, LayoutProps, FlexboxProps {
  isActive?: boolean
  variant?: DragBoxProperty
}

const defaultProps = withDefaultProps<DragBoxProps>({
  variant: 'default',
  transition: 'default',
})

export const DragBox = styled.div
  .attrs<DragBoxProps>(({ isActive, variant }) => ({
    variant: isNil(isActive) ? variant : isActive ? 'active' : 'default',
  }))
  .attrs<DragBoxProps>(defaultProps)(
  css({
    borderRadius: 2,
    borderStyle: 'dashed',
    strokeDasharray: 5,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: mdBumps,
    cursor: 'pointer',
    minHeight: '128px',
    bg: 'chalk',
  }),
  variant({
    variants: {
      default: {
        borderWidth: '1px',
        borderColor: 'dragBoxBorderDefault',
      },
      active: {
        borderWidth: '2px',
        borderColor: 'dragBoxBorderActive',
      },
    },
  }),
  compose(layout, flexbox),
)
